/**
 * @license
 * Copyright (c) 2018 Crius Authors. All rights reserved.
 */

import "@polymer/polymer/polymer-element.js";

const $_documentContainer = document.createElement("template");
$_documentContainer.innerHTML = `
<dom-module id="cs-shared-styles-animations-base">
  <template><style>/** * Asset Enter Animations */:host([animatable]) .cspl-animate__bg {
    animation: var(--cs-animation-enter-background-keyframe-name) var(--cs-animation-timing-long) var(--cs-ease-in-out-long) var(--cs-animation-delay-none) 1 normal forwards paused;
  }

  :host([animatable]) .cspl-animate__mg {
    animation: var(--cs-animation-enter-middleground-keyframe-name) var(--cs-animation-timing-long) var(--cs-ease-in-out-long) var(--cs-animation-delay-none) 1 normal forwards paused;
  }

  :host([animatable][text-align="left"]) .cspl-animate__mg {
    animation: var(--cs-animation-enter-middleground-left-keyframe-name) var(--cs-animation-timing-long) var(--cs-ease-in-out-long) var(--cs-animation-delay-none) 1 normal forwards paused;
  }

  :host([animatable][text-align="right"]) .cspl-animate__mg {
    animation: var(--cs-animation-enter-middleground-right-keyframe-name) var(--cs-animation-timing-long) var(--cs-ease-in-out-long) var(--cs-animation-delay-none) 1 normal forwards paused;
  }

  :host([animatable]) .cspl-animate__fg {
    animation: var(--cs-animation-enter-foreground-keyframe-name) var(--cs-animation-timing-long) var(--cs-ease-in-out-long) var(--cs-animation-delay-none) 1 normal forwards paused;
  }

  :host([animatable][text-align="left"]) .cspl-animate__fg {
    animation: var(--cs-animation-enter-foreground-left-keyframe-name) var(--cs-animation-timing-long) var(--cs-ease-in-out-long) var(--cs-animation-delay-none) 1 normal forwards paused;
  }

  :host([animatable][text-align="right"]) .cspl-animate__fg {
    animation: var(--cs-animation-enter-foreground-right-keyframe-name) var(--cs-animation-timing-long) var(--cs-ease-in-out-long) var(--cs-animation-delay-none) 1 normal forwards paused;
  } /** * Asset Exit Animations */:host([animatable][exit]) .cspl-animate__bg {
    animation: var(--cs-animation-exit-background-keyframe-name) var(--cs-animation-timing-long) var(--cs-ease-in-out-long) var(--cs-animation-delay-none) 1 normal forwards paused;
  }

  :host([animatable][exit]) .cspl-animate__mg {
    animation: var(--cs-animation-exit-middleground-keyframe-name) var(--cs-animation-timing-long) var(--cs-ease-in-out-long) var(--cs-animation-delay-none) 1 normal forwards paused;
  }

  :host([animatable][exit][text-align="left"]) .cspl-animate__mg {
    animation: var(--cs-animation-exit-middleground-left-keyframe-name) var(--cs-animation-timing-long) var(--cs-ease-in-out-long) var(--cs-animation-delay-none) 1 normal forwards paused;
  }

  :host([animatable][exit][text-align="right"]) .cspl-animate__mg {
    animation: var(--cs-animation-exit-middleground-right-keyframe-name) var(--cs-animation-timing-long) var(--cs-ease-in-out-long) var(--cs-animation-delay-none) 1 normal forwards paused;
  }

  :host([animatable][exit]) .cspl-animate__fg {
    animation: var(--cs-animation-exit-foreground-keyframe-name) var(--cs-animation-timing-long) var(--cs-ease-in-out-long) var(--cs-animation-delay-none) 1 normal forwards paused;
  }

  :host([animatable][exit][text-align="left"]) .cspl-animate__fg {
    animation: var(--cs-animation-exit-foreground-left-keyframe-name) var(--cs-animation-timing-long) var(--cs-ease-in-out-long) var(--cs-animation-delay-none) 1 normal forwards paused;
  }

  :host([animatable][exit][text-align="right"]) .cspl-animate__fg {
    animation: var(--cs-animation-exit-foreground-right-keyframe-name) var(--cs-animation-timing-long) var(--cs-ease-in-out-long) var(--cs-animation-delay-none) 1 normal forwards paused;
  } /** * Content Enter Animations */:host([animatable]) .cspl-animate__content {
    animation: var(--cs-animation-enter-content-keyframe-name) var(--cs-animation-timing-long) var(--cs-ease-in-out-long) var(--cs-animation-delay-none) 1 normal forwards paused;
  }

  :host([animatable]) .cspl-animate__eyebrow {
    animation: var(--cs-animation-enter-eyebrow-keyframe-name) var(--cs-animation-timing-short) var(--cs-ease-in-out-short) var(--cs-animation-delay-none) 1 normal forwards paused;
  }

  :host([animatable]) .cspl-animate__title {
    animation: var(--cs-animation-enter-title-keyframe-name) var(--cs-animation-timing-short) var(--cs-ease-in-out-short) var(--cs-animation-delay-short) 1 normal forwards paused;
  }

  :host([animatable]) .cspl-animate__subtitle {
    animation: var(--cs-animation-enter-subtitle-keyframe-name) var(--cs-animation-timing-short) var(--cs-ease-in-out-short) var(--cs-animation-delay-medium) 1 normal forwards paused;
  }

  :host([animatable]) .cspl-animate__body {
    animation: var(--cs-animation-enter-body-keyframe-name) var(--cs-animation-timing-short) var(--cs-ease-in-out-short) var(--cs-animation-delay-medium) 1 normal forwards paused;
  }

  :host([animatable]) .cspl-animate__ctas {
    animation: var(--cs-animation-enter-ctas-keyframe-name) var(--cs-animation-timing-long) var(--cs-ease-in-out-long) var(--cs-animation-delay-long) 1 normal forwards paused;
  } /** * Content Exit Animations */:host([animatable][exit]) .cspl-animate__content {
    animation: var(--cs-animation-exit-content-keyframe-name) var(--cs-animation-timing-long) var(--cs-ease-in-out-long) var(--cs-animation-delay-none) 1 normal forwards paused;
  }

  :host([animatable][exit]) .cspl-animate__eyebrow {
    animation: var(--cs-animation-exit-eyebrow-keyframe-name) var(--cs-animation-timing-short) var(--cs-ease-in-out-short) var(--cs-animation-delay-none) 1 normal forwards paused;
  }

  :host([animatable][exit]) .cspl-animate__title {
    animation: var(--cs-animation-exit-title-keyframe-name) var(--cs-animation-timing-short) var(--cs-ease-in-out-short) var(--cs-animation-delay-short) 1 normal forwards paused;
  }

  :host([animatable][exit]) .cspl-animate__subtitle {
    animation: var(--cs-animation-exit-subtitle-keyframe-name) var(--cs-animation-timing-short) var(--cs-ease-in-out-short) var(--cs-animation-delay-medium) 1 normal forwards paused;
  }

  :host([animatable][exit]) .cspl-animate__body {
    animation: var(--cs-animation-exit-body-keyframe-name) var(--cs-animation-timing-short) var(--cs-ease-in-out-short) var(--cs-animation-delay-medium) 1 normal forwards paused;
  }

  :host([animatable][exit]) .cspl-animate__ctas {
    animation: var(--cs-animation-exit-ctas-keyframe-name) var(--cs-animation-timing-long) var(--cs-ease-in-out-long) var(--cs-animation-delay-long) 1 normal forwards paused;
  } /** * Tile Enter Animations */:host([animatable]) .cspl-animate__tile {
    animation: var(--cs-animation-enter-tile-keyframe-name) var(--cs-animation-timing-short) var(--cs-ease-in-out-short) calc(var(--cs-animation-index) * var(--cs-animation-delay-long)) 1 normal forwards paused;
  }

  @supports (-ms-ime-align: auto) {
    :host([animatable]) .cspl-animate__tile {
      animation: var(--cs-animation-enter-tile-keyframe-name) var(--cs-animation-timing-short) var(--cs-ease-in-out-short) var(--cs-animation-delay-long) 1 normal forwards paused;
      transition: opacity var(--cs-animation-timing-short) var(--cs-ease-in-out-short) var(--cs-animation-delay-long);
    }
  } /** * Tile Exit Animations */:host([animatable][exit]) .cspl-animate__tile {
    animation: var(--cs-animation-exit-tile-keyframe-name) var(--cs-animation-timing-short) var(--cs-ease-in-out-short) calc(var(--cs-animation-index) * var(--cs-animation-delay-long)) 1 normal forwards paused;
  }

  @supports (-ms-ime-align: auto) {
    :host([animatable][exit]) .cspl-animate__tile {
      animation: var(--cs-animation-exit-tile-keyframe-name) var(--cs-animation-timing-short) var(--cs-ease-in-out-short) var(--cs-animation-delay-long) 1 normal forwards paused;
      opacity: 0;
    }
  } /** * Section Enter Animations */:host([animatable]) .cspl-animate__section {
    animation: var(--cs-animation-enter-section-keyframe-name) var(--cs-animation-timing-short) var(--cs-ease-in-out-short) var(--cs-animation-delay-none) 1 normal forwards paused;
  } /** * Section Exit Animations */:host([animatable][exit]) .cspl-animate__section {
    animation: var(--cs-animation-exit-section-keyframe-name) var(--cs-animation-timing-short) var(--cs-ease-in-out-short) var(--cs-animation-delay-none) 1 normal forwards paused;
  } /** * Default Opacity */:host([animatable]) .cspl-animate__bg, :host([animatable]) .cspl-animate__mg, :host([animatable]) .cspl-animate__fg, :host([animatable]) .cspl-animate__content, :host([animatable]) .cspl-animate__eyebrow, :host([animatable]) .cspl-animate__title, :host([animatable]) .cspl-animate__subtitle, :host([animatable]) .cspl-animate__body, :host([animatable]) .cspl-animate__ctas, :host([animatable]) .cspl-animate__tile, :host([animatable]) .cspl-animate__section {
    opacity: 0;
  } /** * Exit Opacity */:host([animatable][exit]) .cspl-animate__bg, :host([animatable][exit]) .cspl-animate__mg, :host([animatable][exit]) .cspl-animate__fg, :host([animatable][exit]) .cspl-animate__content, :host([animatable][exit]) .cspl-animate__eyebrow, :host([animatable][exit]) .cspl-animate__title, :host([animatable][exit]) .cspl-animate__subtitle, :host([animatable][exit]) .cspl-animate__body, :host([animatable][exit]) .cspl-animate__ctas, :host([animatable][exit]) .cspl-animate__tile, :host([animatable][exit]) .cspl-animate__section {
    opacity: 1;
  } /** * No Enter Animation Opacity */:host([animatable]) .cspl-animate__bg[animate-enter-off], :host([animatable]) .cspl-animate__mg[animate-enter-off], :host([animatable]) .cspl-animate__fg[animate-enter-off], :host([animatable]) .cspl-animate__content[animate-enter-off], :host([animatable]) .cspl-animate__eyebrow[animate-enter-off], :host([animatable]) .cspl-animate__title[animate-enter-off], :host([animatable]) .cspl-animate__subtitle[animate-enter-off], :host([animatable]) .cspl-animate__body[animate-enter-off], :host([animatable]) .cspl-animate__ctas[animate-enter-off], :host([animatable]) .cspl-animate__tile[animate-enter-off], :host([animatable]) .cspl-animate__section[animate-enter-off] {
    opacity: 1;
  }

  :host([animate][animatable]) .cspl-animate__bg, :host([animate][animatable]) .cspl-animate__mg, :host([animate][animatable]) .cspl-animate__fg, :host([animate][animatable][text-align]) .cspl-animate__mg, :host([animate][animatable][text-align]) .cspl-animate__fg, :host([animate][animatable]) .cspl-animate__content, :host([animate][animatable]) .cspl-animate__eyebrow, :host([animate][animatable]) .cspl-animate__title, :host([animate][animatable]) .cspl-animate__subtitle, :host([animate][animatable]) .cspl-animate__body, :host([animate][animatable]) .cspl-animate__ctas, :host([animate][animatable]) .cspl-animate__tile, :host([animate][animatable]) .cspl-animate__section {
    animation-play-state: running;
  }

  @supports (-ms-ime-align: auto) {
    :host([animate][animatable]) .cspl-animate__tile {
      opacity: 1;
    }
  }</style></template></dom-module>`;

document.head.appendChild($_documentContainer.content);
